import { FunctionComponent } from "react";

import styled from "styled-components";
import { useTranslations } from "next-intl";

import { Layout, SmallTitle, StandardText, ErrorIcon, StickyButton } from "@src/packages/chime-ui";
import { LoginPrompt } from "@src/packages/chime-ui/components/LoginPrompt";
import { Content } from "@src/packages/chime-ui/components/Content";

const ErrorContent = styled(Content)`
  padding: 3rem 0 0;
`;

export const Error: FunctionComponent = () => {
  const t = useTranslations("error");

  return (
    <Layout>
      <ErrorContent fullHeight={true}>
        <ErrorIcon />
        <SmallTitle>{t("title")}</SmallTitle>
        <StandardText>{t("description")}</StandardText>
      </ErrorContent>
      <StickyButton as="a" href="https://help.chime.com/hc/en-us/articles/224860707-How-do-I-contact-Chime">
        {t("cta")}
      </StickyButton>
      <LoginPrompt />
    </Layout>
  );
};
